import { getFeaturesContext } from '@vp/ft-context-reader';
import { Logger, getsdkKeyOrDefault, FeaturesClientCore } from '@vp/ft-reader-core';
import { enums } from '@optimizely/optimizely-sdk';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var localStorageKeyPrefix = 'optimizelyDataFile-';
var expirationTimeMilis = 300000;

var decodeContext = encodedContext => {
  return JSON.parse(window.atob(encodedContext));
};

var getDataFileFromLocalStorage = (logger, sdkKey) => {
  try {
    var storedDataFile = JSON.parse(localStorage.getItem(localStorageKeyPrefix + sdkKey) || '{}');

    if (storedDataFile && storedDataFile.timeStamp && new Date().getTime() - storedDataFile.timeStamp < expirationTimeMilis && storedDataFile.dataFile) {
      return storedDataFile.dataFile;
    }
  } catch (error) {
    logger.error('Error getting datafile from localStorage', error);
  }

  return undefined;
};

var storeDataFileInLocalStorage = optimizelyClient => {
  var config = optimizelyClient.getOptimizelyConfig();

  if (!config || !config.sdkKey) {
    return;
  }

  localStorage.setItem(localStorageKeyPrefix + config.sdkKey, JSON.stringify({
    timeStamp: new Date().getTime(),
    dataFile: config.getDatafile()
  }));
};

class FeaturesClient {
  constructor(coreFeaturesClient, logger) {
    if (!coreFeaturesClient || !coreFeaturesClient.optimizelyClient) {
      throw new Error('Invalid optimizely client given');
    }

    this.coreFeaturesClient = coreFeaturesClient;
    this.logger = logger;
  }

  static getFeaturesClient(libraryName, sdkKey) {
    return _asyncToGenerator(function* () {
      var logger = Logger.getLogger('0.10.1', 'ft-reader-browser', libraryName);
      sdkKey = getsdkKeyOrDefault(sdkKey);
      var dataFile = getDataFileFromLocalStorage(logger, sdkKey);
      var featuresClientCore = yield FeaturesClientCore.getFeaturesClient(logger, sdkKey, dataFile);
      featuresClientCore.optimizelyClient.notificationCenter.addNotificationListener(enums.NOTIFICATION_TYPES.OPTIMIZELY_CONFIG_UPDATE, () => {
        storeDataFileInLocalStorage(featuresClientCore.optimizelyClient);
      });

      if (!dataFile) {
        storeDataFileInLocalStorage(featuresClientCore.optimizelyClient);
      }

      return new FeaturesClient(featuresClientCore, logger);
    })();
  }

  isFeatureEnabled(featureName) {
    var context = this.getDecodedFeatureContext();
    return this.coreFeaturesClient.isFeatureEnabled(featureName, context);
  }

  getEnabledFeatures() {
    var context = this.getDecodedFeatureContext();
    return this.coreFeaturesClient.getEnabledFeatures(context);
  }

  getDecodedFeatureContext() {
    try {
      return decodeContext(getFeaturesContext());
    } catch (e) {
      this.logger.error('Could not get context from cookie. Generating a new one', e);
      return undefined;
    }
  }

}

export { FeaturesClient };
//# sourceMappingURL=ft-reader.esm.js.map
